import { BackTop } from 'antd'
import styled from 'styled-components'

export const StyledBackTop = styled(BackTop)`
  bottom: 100px !important;
  right: 30px !important;
`
